import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { memo, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CustomDropDown from "../../../components/select";
import { AppContext } from "../../../lib/Context";
import { getProspectDiscount } from "../../../services/DiscountApiFn";
import {
  handleOpenSnackBar,
  selectedContractLength,
} from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  setDiscount,
  setDiscountDetails,
  resetDiscount,
} from "../../../lib/redux/slices/discountSlice";

const Discount = () => {
  const location = useLocation();
  const {
    userData,
    contractLength,
    calculateGrossProfit,
    calculateOneOfCostProfit,
  } = useContext(AppContext);
  const dispatch = useDispatch();
  const isDetailPage = location.pathname === "/prospect-details";
  const [allDiscount, setAllDiscount] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const totalGrossProfit =
    parseFloat(calculateGrossProfit()) + parseFloat(calculateOneOfCostProfit());
  const selectedLength = selectedContractLength(contractLength)?.value;

  const { discount, discountDetails } = useSelector(
    (state) => state.discountReducer
  );


  useEffect(() => {
    if (selectedLength && totalGrossProfit > 0) {
      fetchAllDiscount(selectedLength, totalGrossProfit);
    } else {
      // Clear discount data when conditions are not met
      dispatch(resetDiscount());
      setAllDiscount([]);
    }
  }, [selectedLength, totalGrossProfit]);

  const fetchAllDiscount = async (length, profit) => {
    try {
      setIsLoading(true);
      const response = await getProspectDiscount(length, profit);
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setAllDiscount(data);
        
        // Clear discount data if no discounts are available
        if (!data || data.length === 0) {
          dispatch(resetDiscount());
        } else {
          // Check if current selected discount still exists in new data
          if (discount && !data.find(d => d._id === discount)) {
            dispatch(resetDiscount());
          }
        }
      } else {
        handleOpenSnackBar("error", response?.data.message);
        dispatch(resetDiscount());
        setAllDiscount([]);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
      dispatch(resetDiscount());
      setAllDiscount([]);
    } finally {
      setIsLoading(false);
    }
  };

  

  if (allDiscount?.length > 0) {
    return (
      <Box mt={2} mb={5}>
        <Typography variant="h6" color={"text.charcoalGrey"}>
          Discount
        </Typography>

        <Grid container mt={0} spacing={2}>
          <Grid item xs={12} md={3}>
            <CustomDropDown
              variant="filled"
              value={discount}
              onChange={(e) => {
                dispatch(setDiscount(e.target.value));

                const selectedDiscount = allDiscount.find(
                  (val) => val._id === e.target.value
                );

                dispatch(
                  setDiscountDetails(selectedDiscount ? selectedDiscount : null)
                );
              }}
              readonly={isDetailPage}
            >
              <MenuItem value={null}>None</MenuItem>
              {allDiscount.map((val, ind) => (
                <MenuItem key={ind} value={val._id}>
                  {val.code}
                </MenuItem>
              ))}
            </CustomDropDown>
          </Grid>
        </Grid>
      </Box>
    );
  }
};

export default memo(Discount);
